import React, { Component } from 'react';
import {connect} from "react-redux";
import PageHeader from "../components/PageHeader";
import Loading from "../components/Loading";
import Button from "../components/Button";
import Conditional from "../components/Conditional";
import Products from "./views/Products";
import OrderSummary from "./views/OrderSummary";
import PlaceOrderButton from "./shared/PlaceOrderButton";
import PromoCodeFormContainer from "./forms/PromoCodeFormContainer";
import SelectPaymentMethodV2 from "./shared/SelectPaymentMethodV2"
import SelectShippingAddress from "./shared/SelectShippingAddress"
import SelectBillingAddress from "./shared/SelectBillingAddress"
import PromoCode from "./shared/PromoCode"
import {requestAddShippingAddress, requestEditShippingAddress} from "../actions/AccountApiActions";
import {requestCancelCheckout, requestShowOrderStatus, requestAddGiftMessage, requestEditGiftMessage, requestRemoveGiftMessage} from "../actions/CheckoutApiActions";
import {CHECKOUT_INFO, ON_CHECKOUT_INFO_UPDATED, ON_UPDATED_BILLING} from "../queries/sales";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {fromJS} from "immutable";
import "./CheckoutPage.css";

function isGifting(data) {
  return data.get("gift") === true;
}

function isGiftingEmailValid(checkoutData, accountHolder) {
  let email = checkoutData.getIn(["shippingAddress", "email"], "");
  if (email === "") return false;
  if (email === accountHolder.get("email")) return false;
  return true;
} 

class CheckoutPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      paid: false,
      expired: false,
      failed: false,
      invoiceNr: "",
      status: "waiting",
      errorMsg: "",
      lastAttempt: 0,
      showConfirmation: false,
      giftingExpanded: false,      
    }
  }

  UNSAFE_componentWillMount() {
    this.props.subscribeToUpdates(this.props, {}); 
    this.props.subscribeToBillingUpdates(this.props, {});
  }

  componentWillUnmount() {
    if (!this.state.paid && !this.state.expired && !this.state.failed) {
      // The router params have already changed when we get here.
      if (this.props.data && this.props.data.checkoutInfo) {
        this.props.requestCancelCheckout(
          this.props.data.checkoutInfo.accountId,
          this.props.data.checkoutInfo.orderId,
          false
        )        
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.status !== this.state.status) {
      switch(this.state.status) {
        case "started":
          this.props.requestShowOrderStatus(this.props.router.params.accountId, this.props.router.params.orderId, "submitting");
          this.makePayment();
          break;
        case "paid":
        case "billed":
          this.props.requestShowOrderStatus(this.props.router.params.accountId, this.props.router.params.orderId, "success", "", this.state.invoiceNr);
          break;
        case "failed":
          this.props.requestShowOrderStatus(this.props.router.params.accountId, this.props.router.params.orderId, "error", this.state.errorMsg);
          break;
        case "authenticate":
          this.props.requestShowOrderStatus(this.props.router.params.accountId, this.props.router.params.orderId, "authenticate");
          break;
        default:
          // Do nothing.
      }
    }
    if (!this.props.data.loading && this.props.data && this.props.data.checkoutInfo) {
      if (prevProps.data.checkoutInfo && this.props.data.checkoutInfo.total !== prevProps.data.checkoutInfo.total) {
        this.notifyTotalChange();
      }
      // Ok billing status changed.
      if (this.props.data.checkoutInfo.billingStatus === "authentication_required" && this.state.status !== "authenticate") {
        this.setState({status: "authenticate"});
      } else if (this.props.data.checkoutInfo.expired && !this.state.expired) {
        this.setState({expired: true});
      // } else if (this.props.data.checkoutInfo.status === "checkout_failed" && !this.state.failed) {
      //   this.setState({failed: true});
      } else if (this.state.lastAttempt !== this.props.data.checkoutInfo.billingAttempt) {
        switch(this.props.data.checkoutInfo.billingStatus) {
          case "paid":
          case "billed":
            this.setState({status: "paid", paid: true, invoiceNr: this.props.data.checkoutInfo.invoiceNr, lastAttempt: this.props.data.checkoutInfo.billingAttempt});
            break;
          case "failed":
            this.setState({status: "failed", errorMsg: this.props.data.checkoutInfo.billingError, lastAttempt: this.props.data.checkoutInfo.billingAttempt});
            break;
          default:
            // do nothing
        }
      }
    }
  }  
  
  render() {
    let {loading, error, checkoutInfo, shippingAddresses, billingAccount, billingDefaultPaymentMethod, accountHolder} = this.props.data;
    if (loading) return <Loading />
    // If there is an error we just keep showing the Loading, because 99% of the time it will be because the
    // order has not yet fully populated.
    if (error) return <Loading />

    
    let checkoutData = fromJS(checkoutInfo);
    let shippingAddress = checkoutData.get("shippingAddress");
    let usedShippingAddresses = fromJS(shippingAddresses);
    billingAccount = fromJS(billingAccount);  
    accountHolder = fromJS(accountHolder);  
    if (checkoutData.get("status") === "checkout_failed_insufficient_stock") {
      return <h1>Insufficient Stock</h1>
    }
    if (checkoutData.get("status") === "checkout_failed") {
      return <h1>Checkout Failed</h1>
    }
    if (checkoutData.get("expired") === true) {
      return <h1>Checkout Expired</h1>
    }
    const defaultPaymentMethod = fromJS(billingDefaultPaymentMethod);
    const paymentTerms = billingAccount.get("paymentMethod") === "payment_terms";
    let giftingValid = true;
    if (isGifting(checkoutData) && !isGiftingEmailValid(checkoutData, accountHolder)) {
      giftingValid = false;
    }    
    let canPay = checkoutData.get("canPay") === true && (defaultPaymentMethod || paymentTerms) && !this.state.submitting && giftingValid;
    let title = `Checkout for ${accountHolder.get("name")} `;

    return (
      <div className="CheckoutPage SecurePage">
        <PageHeader title={title} />
        <div className="PageContainer">
          <div className="sections">
            <Conditional show={checkoutData.get("gift") === true}>
              <div className="giftingBox">
                <h4>Gift Message</h4>
                <pre>{checkoutData.get("giftMessage")}</pre>
                <div className="buttons">
                  <Button label="Remove Message" primary={false} onClick={this.handleRemoveGiftMessage.bind(this)} />
                  <Button label="Edit Message" primary={true} onClick={this.handleEditGiftMessage.bind(this, checkoutData.get("giftMessage"))} />
                </div>
              </div>
              <div className="divider" />
            </Conditional>
            <SelectShippingAddress
              accountId={checkoutData.get("accountId")}
              orderId={checkoutData.get("orderId")}
              status={checkoutData.get("shippingAddressStatus")}
              shippingAddress={shippingAddress}
              usedShippingAddresses={usedShippingAddresses}
              canChangeAddress={checkoutData.get("canChangeAddress")}
              canSetDeliveryInstructions={false}
              showGifting={checkoutData.get("gift") === false}
              />
            <div className="divider" />
            <SelectPaymentMethodV2
              accountId={checkoutData.get("accountId")}
              orderId={checkoutData.get("orderId")}
              paymentMethod={billingAccount.get("paymentMethod")}
              paymentTermsDays={billingAccount.get("paymentTermsDays")}
              defaultPaymentMethod={defaultPaymentMethod}
              />
            <div className="divider" />
            <SelectBillingAddress
              accountId={checkoutData.get("accountId")}
              billingAddress={checkoutData.get("billingAddress")}
              billingAddressStatus={checkoutData.get("billingDetailsStatus")}
              shippingAddressStatus={checkoutData.get("shippingAddressStatus")}
              shippingAddress={shippingAddress}
              billingTaxId={checkoutData.get("billingTaxId")}
              billingTaxExempt={checkoutData.get("billingTaxExempt")}
              billingTaxExemptionDescription={checkoutData.get("billingTaxExemptionDescription")}
              />                
            <div className="divider" />
            <Products
              products={checkoutData.get("products")}
              subscriptionName={checkoutData.get("subscriptionName")}
              subscriptionFrequencyWeeks={checkoutData.get("subscriptionFrequencyWeeks")}
              />
          </div>
        </div>
        <div className="PanelContainer">
          <OrderSummary 
            data={checkoutData} />
          <Conditional show={checkoutData.get("promoCodeApplied") === true && checkoutData.get("discount") === "--"}>
            <p>Please note that "Promo Code Discount" will be calulcated and displayed once shipping and billing details have been provided.</p>
          </Conditional>            
          <div className="PromoComponents">
            <PromoCodeFormContainer 
              orderId={checkoutData.get("orderId")}/>
            <PromoCode
              active={checkoutData.get("promoCodeApplied") === true}
              code={checkoutData.get("promoCode")}
              />
          </div>
          <PlaceOrderButton onClick={this.handleStartPayment.bind(this)} active={canPay} />
          <Button label="Cancel Checkout" primary={false} onClick={this.handleCancelCheckout.bind(this)} />
          <p></p>
          <Conditional show={checkoutData.get("gift") === false}>
            <Button label="Add Gift Message" primary={true} onClick={this.handleAddGiftMessage.bind(this)} />
          </Conditional>
        </div>
      </div>
    );
  }

  renderView(page) {
    return (
      <div>
        <p>Checkout View</p>
      </div>
    )
  }

  handleAddShippingAddress(accountId) {
    this.props.requestAddShippingAddress(accountId);    
  }

  handleAddGiftMessage() {
    this.props.requestAddGiftMessage(this.props.router.params.orderId);
  }
  
  handleEditGiftMessage(message) {
    this.props.requestEditGiftMessage(this.props.router.params.orderId, message);
  }

  handleRemoveGiftMessage() {
    this.props.requestRemoveGiftMessage(this.props.router.params.orderId);
  }

  makePayment() {
    let values = {
      orderId: this.props.router.params.orderId
    }
    this.props.placeOrder(values)
      .then((response) => {
        if (response.data.placeOrder.errors.length <= 0) {
          this.setState({status: "submitted"});
        } else {
          console.warn("ORDER ERROR", response.data.placeOrder.errors);
          this.setState({status: "failed", errorMsg: "unknown"});
        }
      })
      .catch((err) => {
        console.warn("ORDER ERROR!!", err);
        this.setState({status: "failed", errorMsg: "unknown"})
      });    
  }

  notifyTotalChange(newTotal) {
    // this.props.showNotification(generateUUID(), "Order total changed.");
  }

  handleStartPayment() {
    this.setState({status: "started"});
  }

  handleCancelCheckout() {
    this.props.requestCancelCheckout(
      this.props.router.params.accountId,
      this.props.router.params.orderId
    )
  }  

}

const PLACE_ORDER = gql`
  mutation placeOrder($data: PlaceOrderInput!) {
    placeOrder(input: $data) {
      errors { key message }
    }
  }
`;


const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_CHECKOUT_INFO_UPDATED,
      variables: {
        orderId: props.router.params.orderId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  },
  subscribeToBillingUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_BILLING,
      variables: {
        accountId: props.router.params.accountId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  },  
  requestAddShippingAddress: (accountId) => {
    dispatch(requestAddShippingAddress(accountId))
  },
  requestEditShippingAddress: requestEditShippingAddress,
  requestAddGiftMessage: (orderId) => {
    dispatch(requestAddGiftMessage(orderId));
  },
  requestEditGiftMessage: (orderId, message) => {
    dispatch(requestEditGiftMessage(orderId, message));
  },
  requestRemoveGiftMessage: (orderId) => {
    dispatch(requestRemoveGiftMessage(orderId));
  },
  requestCancelCheckout: (accountId, orderId, redirect = true) => {
    dispatch(requestCancelCheckout(accountId, orderId, redirect));
  },
  requestShowOrderStatus: (accountId, orderId, status, errorMsg, invoiceNr) => {
    dispatch(requestShowOrderStatus(accountId, orderId, status, errorMsg, invoiceNr));
  }  
})

const withQuery = compose(
  graphql(CHECKOUT_INFO, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.router.params.accountId,
        orderId: props.router.params.orderId
      }
    })
  }),
  graphql(PLACE_ORDER, {
    props: ({mutate}) => ({
      placeOrder: (data) => mutate({
        variables: { data: data }
      })
    })
  })
)

export default connect(null, mapDispatchToProps)(withQuery(CheckoutPage));